import React, { useEffect, useState, cloneElement, Component } from 'react';
import { motion } from 'framer-motion';
import { SparkleEffect } from '../components/SparkleEffect';
import { PlaneIcon, MapIcon, CompassIcon, SparklesIcon } from 'lucide-react';
import { GlitterHeart } from '../components/GlitterHeart';
function RegularTravelForm() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [contactMethod, setContactMethod] = useState('');
  const [contactDetails, setContactDetails] = useState('');
  const [tripTypes, setTripTypes] = useState<string[]>([]);
  const [travelDates, setTravelDates] = useState('');
  const [destination, setDestination] = useState('');
  const [budget, setBudget] = useState('');
  const [extra, setExtra] = useState('');
  const toggleTripType = (type: string) => {
    setTripTypes(prev => prev.includes(type) ? prev.filter(t => t !== type) : [...prev, type]);
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');
    try {
      const formData = new FormData();
      formData.append('fields[email]', email);
      formData.append('fields[z_i_p]', name);
      formData.append('fields[name]', contactMethod);
      formData.append('fields[last_name]', contactDetails);
      tripTypes.forEach(t => formData.append('fields[company][]', t));
      formData.append('fields[country]', travelDates);
      formData.append('fields[city]', destination);
      formData.append('fields[phone]', budget);
      formData.append('fields[state]', extra);
      formData.append('ml-submit', '1');
      formData.append('anticsrf', 'true');
      await fetch('https://assets.mailerlite.com/jsonp/2211088/forms/182588858091702005/subscribe', {
        method: 'POST',
        body: formData,
        mode: 'no-cors'
      });
      setStatus('success');
    } catch {
      setStatus('error');
    }
  };
  if (status === 'success') {
    return <div className="bg-white/80 rounded-2xl p-8 text-center border border-blush-200" data-id="element-3277" data-mp="1nyndmkjyo098">
        <p className="font-heading text-2xl font-bold text-plum-700 mb-2" data-id="element-3278" data-mp="1stb4ur6cn8ri">
          ✈️ You're all set!
        </p>
        <p className="text-plum-500 font-medium" data-id="element-3279" data-mp="1e0hgeg93niap">
          I'll review your trip request and reach out soon. Let's get you out of
          here! 💖
        </p>
      </div>;
  }
  return <form onSubmit={handleSubmit} className="space-y-5" data-id="element-3280" data-mp="26p53mhdeshqw">
      <div data-id="element-3281" data-mp="2borh8rx5g008">
        <label className="block text-sm font-bold text-plum-700 mb-1.5" data-id="element-3282" data-mp="2bpkgz8xoxp8v">
          Name
        </label>
        <input type="text" required value={name} onChange={e => setName(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-blush-200 focus:ring-2 focus:ring-cta-500 outline-none bg-white/80" placeholder="Your name" data-id="element-3283" data-mp="1wsaa6cvzt7jh" />
      </div>
      <div data-id="element-3284" data-mp="qan1zu94tloc">
        <label className="block text-sm font-bold text-plum-700 mb-1.5" data-id="element-3285" data-mp="34kijpq9bn7q4">
          Email
        </label>
        <input type="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-blush-200 focus:ring-2 focus:ring-cta-500 outline-none bg-white/80" placeholder="your@email.com" data-id="element-3286" data-mp="2zlebp2y4vg1d" />
      </div>
      <div data-id="element-3287" data-mp="2lt7x3lamph41">
        <label className="block text-sm font-bold text-plum-700 mb-1.5" data-id="element-3288" data-mp="2lv2h8xe2t572">
          Best way to contact you
        </label>
        <select required value={contactMethod} onChange={e => setContactMethod(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-blush-200 focus:ring-2 focus:ring-cta-500 outline-none bg-white/80 text-plum-700" data-id="element-3289" data-mp="2gwr86ovluypw">
          <option value="" data-id="element-3290" data-mp="224pb1ckx6jtk">Select...</option>
          <option value="phone" data-id="element-3291" data-mp="1y4ewvcmz4n3m">Phone</option>
          <option value="text" data-id="element-3292" data-mp="1y3dhivyxdeg3">Text</option>
          <option value="email" data-id="element-3293" data-mp="1y2lyekmil96p">Email</option>
        </select>
      </div>
      <div data-id="element-3294" data-mp="2av8pwvcv45ti">
        <label className="block text-sm font-bold text-plum-700 mb-1.5" data-id="element-3295" data-mp="2arkyq2uw3vhy">
          Enter your contact details
        </label>
        <input type="text" required value={contactDetails} onChange={e => setContactDetails(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-blush-200 focus:ring-2 focus:ring-cta-500 outline-none bg-white/80" placeholder="Phone number or email" data-id="element-3296" data-mp="2krtw3k0mbmyx" />
      </div>
      <div data-id="element-3297" data-mp="2yhxicazhzgod">
        <label className="block text-sm font-bold text-plum-700 mb-2" data-id="element-3298" data-mp="2yhfasi7dxg15">
          What kind of trip? (select all that apply)
        </label>
        <div className="flex flex-wrap gap-3" data-id="element-3299" data-mp="38h63qfgarmz4">
          {['cruise', 'hotel', 'plane', 'rent a car', 'other'].map(type => <label key={type} className="flex items-center gap-2 cursor-pointer" data-id="element-3300" data-mp="195c1f9atwk2g">
              <input type="checkbox" checked={tripTypes.includes(type)} onChange={() => toggleTripType(type)} className="w-4 h-4 rounded border-blush-300 text-cta-500 focus:ring-cta-500" data-id="element-3301" data-mp="1e3x0v6i9azpu" />
              <span className="text-plum-600 font-medium text-sm capitalize" data-id="element-3302" data-mp="wt9r739z5x6l">
                {type}
              </span>
            </label>)}
        </div>
      </div>
      <div data-id="element-3303" data-mp="1pigknnuknwkz">
        <label className="block text-sm font-bold text-plum-700 mb-1.5" data-id="element-3304" data-mp="1pj9syt96iu58">
          Travel Dates?
        </label>
        <input type="text" value={travelDates} onChange={e => setTravelDates(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-blush-200 focus:ring-2 focus:ring-cta-500 outline-none bg-white/80" placeholder="Exact dates or 'flexible'" data-id="element-3305" data-mp="1kkouozdhmkjf" />
      </div>
      <div data-id="element-3306" data-mp="46ox3v2476zc">
        <label className="block text-sm font-bold text-plum-700 mb-1.5" data-id="element-3307" data-mp="43av4nxd4zsf">
          Where would you like to go?
        </label>
        <input type="text" value={destination} onChange={e => setDestination(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-blush-200 focus:ring-2 focus:ring-cta-500 outline-none bg-white/80" placeholder="E.g., Mexico, Europe, or 'Anywhere warm!'" data-id="element-3308" data-mp="2ncj035sc5uxb" />
      </div>
      <div data-id="element-3309" data-mp="2ibvcyv789y8d">
        <label className="block text-sm font-bold text-plum-700 mb-1.5" data-id="element-3310" data-mp="2ibbrj4idcrpl">
          Budget range
        </label>
        <input type="text" value={budget} onChange={e => setBudget(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-blush-200 focus:ring-2 focus:ring-cta-500 outline-none bg-white/80" placeholder="E.g., $500–$1000" data-id="element-3311" data-mp="23m5u9m33dbkc" />
      </div>
      <div data-id="element-3312" data-mp="1zkared5iiq4g">
        <label className="block text-sm font-bold text-plum-700 mb-1.5" data-id="element-3313" data-mp="1kpo5ndjjhrsb">
          Anything else you want me to know?
        </label>
        <input type="text" value={extra} onChange={e => setExtra(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-blush-200 focus:ring-2 focus:ring-cta-500 outline-none bg-white/80" placeholder="Special requests, accessibility needs, etc." data-id="element-3314" data-mp="1pnfxk7k6pdwi" />
      </div>
      <button type="submit" disabled={status === 'loading'} className="w-full py-4 rounded-full bg-cta-500 text-white font-bold text-lg hover:bg-cta-600 transition-all shadow-lg disabled:opacity-60" data-id="element-3315" data-mp="1fysh4qncz01l">
        {status === 'loading' ? '...' : '✈️ Build My Trip!'}
      </button>
      {status === 'error' && <p className="text-red-500 text-xs font-medium" data-id="element-3316" data-mp="1yrwdijrynqzw">
          Something went wrong. Please try again.
        </p>}
    </form>;
}
function BudgetTravelForm() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [contactMethod, setContactMethod] = useState('');
  const [contactDetails, setContactDetails] = useState('');
  const [budget, setBudget] = useState('');
  const [unavailableDates, setUnavailableDates] = useState('');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');
    try {
      const formData = new FormData();
      formData.append('fields[email]', email);
      formData.append('fields[city]', name);
      formData.append('fields[name]', contactMethod);
      formData.append('fields[last_name]', contactDetails);
      formData.append('fields[company]', budget);
      formData.append('fields[country]', unavailableDates);
      formData.append('ml-submit', '1');
      formData.append('anticsrf', 'true');
      await fetch('https://assets.mailerlite.com/jsonp/2211088/forms/182588184542053728/subscribe', {
        method: 'POST',
        body: formData,
        mode: 'no-cors'
      });
      setStatus('success');
    } catch {
      setStatus('error');
    }
  };
  if (status === 'success') {
    return <div className="bg-white/80 rounded-2xl p-8 text-center border border-sky-200" data-id="element-3317" data-mp="255pknsejsd32">
        <p className="font-heading text-2xl font-bold text-plum-700 mb-2" data-id="element-3318" data-mp="215f5pq8s2cc2">
          ✈️ You're on the list!
        </p>
        <p className="text-plum-500 font-medium" data-id="element-3319" data-mp="1w7x64qgnh9gq">
          I'll find you something amazing within your budget. Get ready! 💖
        </p>
      </div>;
  }
  return <form onSubmit={handleSubmit} className="space-y-5" data-id="element-3320" data-mp="1m8g2eekyl5ne">
      <div data-id="element-3321" data-mp="1hh6djg78i6ck">
        <label className="block text-sm font-bold text-plum-700 mb-1.5" data-id="element-3322" data-mp="1hgefzzu2tyjn">
          Name
        </label>
        <input type="text" required value={name} onChange={e => setName(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-sky-200 focus:ring-2 focus:ring-cta-500 outline-none bg-white/80" placeholder="Your name" data-id="element-3323" data-mp="1dejhf33j5z9k" />
      </div>
      <div data-id="element-3324" data-mp="yj3jgmztxj7w">
        <label className="block text-sm font-bold text-plum-700 mb-1.5" data-id="element-3325" data-mp="yilpxy4jxj3o">
          Email
        </label>
        <input type="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-sky-200 focus:ring-2 focus:ring-cta-500 outline-none bg-white/80" placeholder="your@email.com" data-id="element-3326" data-mp="2oz8dedivx6yf" />
      </div>
      <div data-id="element-3327" data-mp="2ttvrdig9iiyr">
        <label className="block text-sm font-bold text-plum-700 mb-1.5" data-id="element-3328" data-mp="261xfoxcwill3">
          Best way to contact you
        </label>
        <select required value={contactMethod} onChange={e => setContactMethod(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-sky-200 focus:ring-2 focus:ring-cta-500 outline-none bg-white/80 text-plum-700" data-id="element-3329" data-mp="213dtqwyb59sq">
          <option value="" data-id="element-3330" data-mp="3qhijx5a7th6x">Select...</option>
          <option value="Phone" data-id="element-3331" data-mp="3qgh5qrxwkekz">Phone</option>
          <option value="Text" data-id="element-3332" data-mp="3lipfe2cwp0iw">Text</option>
          <option value="Email" data-id="element-3333" data-mp="3lhnw5alql7q3">Email</option>
        </select>
      </div>
      <div data-id="element-3334" data-mp="3tz6m9tsvbvtp">
        <label className="block text-sm font-bold text-plum-700 mb-1.5" data-id="element-3335" data-mp="3tzg9xaqfxqw8">
          Enter your contact details
        </label>
        <input type="text" required value={contactDetails} onChange={e => setContactDetails(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-sky-200 focus:ring-2 focus:ring-cta-500 outline-none bg-white/80" placeholder="Phone number or email" data-id="element-3336" data-mp="1xgqv4rt40jv" />
      </div>
      <div data-id="element-3337" data-mp="ljmwj4reovje">
        <label className="block text-sm font-bold text-plum-700 mb-1.5" data-id="element-3338" data-mp="lkef9ezwmys9">
          Budget
        </label>
        <input type="text" required value={budget} onChange={e => setBudget(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-sky-200 focus:ring-2 focus:ring-cta-500 outline-none bg-white/80" placeholder="E.g., $300, $500, $1000" data-id="element-3339" data-mp="6vs2nl1nwl4q" />
      </div>
      <div data-id="element-3340" data-mp="14byulfb11anq">
        <label className="block text-sm font-bold text-plum-700 mb-1.5" data-id="element-3341" data-mp="14ch0l3nhr38u">
          Any dates you're unable to travel?
        </label>
        <input type="text" value={unavailableDates} onChange={e => setUnavailableDates(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-sky-200 focus:ring-2 focus:ring-cta-500 outline-none bg-white/80" placeholder="E.g., 'Not available in December'" data-id="element-3342" data-mp="197jh2mz5yd1x" />
      </div>
      <button type="submit" disabled={status === 'loading'} className="w-full py-4 rounded-full bg-plum-700 text-white font-bold text-lg hover:bg-plum-900 transition-all shadow-lg disabled:opacity-60" data-id="element-3343" data-mp="v938srlnkeho">
        {status === 'loading' ? '...' : '✈️ Surprise Me!'}
      </button>
      {status === 'error' && <p className="text-red-500 text-xs font-medium" data-id="element-3344" data-mp="ch0zy2f962hz">
          Something went wrong. Please try again.
        </p>}
    </form>;
}
const RealisticPlane = ({
  flip = false,
  size = 48
}: {
  flip?: boolean;
  size?: number;
}) => <svg width={size} height={size} viewBox="0 0 512 512" fill="currentColor" style={{
  transform: flip ? 'scaleX(-1)' : undefined
}} data-id="element-3345" data-mp="2j483ojxhblfg">
    <path d="M186.6 25.1c-8.8-2.9-18.4.8-22.8 8.9L97.2 152.5c-2.5 4.6-2.5 10.1-.1 14.7l13.6 26.2L15.8 227c-10.1 3.4-16.7 12.5-16.7 22.8v32.7c0 10.3 6.6 19.5 16.4 22.8l94.8 32.5 13.7 26.4c2.4 4.6 2.4 10.1-.1 14.7L57.8 497c-4.4 8.1-1 18.2 7.8 22.8 3.1 1.6 6.4 2.2 9.7 2.2 5.8 0 11.5-2.6 15.2-7.4L199.8 370c3.5-4.5 4.5-10.5 2.6-16l-12.4-35.8 122.3-41.9c3.3-1.1 6.1-3.4 7.9-6.4l68.4-115.5c1.5-2.5 2.2-5.4 2.2-8.3V128c0-4.2-1.7-8.3-4.7-11.3l-22.6-22.6c-3-3-7.1-4.7-11.3-4.7h-18.1c-2.9 0-5.8.7-8.3 2.2L210.3 160.1c-3 1.8-5.3 4.6-6.4 7.9l-41.9 122.3-35.8-12.4c-5.5-1.9-11.5-.9-16 2.6L-4.5 389.8" opacity="0.35" data-id="element-3346" data-mp="2s67l3dceorix" />
    <path d="M497 2.5c-4.6-4.4-11.8-4.4-16.4.1L338.3 147.9 210.8 91.4c-4.7-2.1-10.2-1.3-14.1 2l-28.9 24.8L42.5 68.6C31.9 65.1 20.6 71 17.1 81.6l-11.3 33.8c-3.5 10.5 2.4 21.8 12.9 25.4l125.3 42.8 24.9-28.8c3.4-3.9 4.1-9.4 2-14.1l-56.5-127.5L259.7 155c4.5 4.5 11.8 4.5 16.3 0L509.5 18.9c4.5-4.6 4.5-12-.1-16.4h-12.4z" opacity="0.5" data-id="element-3347" data-mp="1grkjbj9vtvdk" />
  </svg>;
function ScrollPlane({
  topStart,
  topEnd,
  reverse = false,
  size = 44
}: {
  topStart: number;
  topEnd: number;
  reverse?: boolean;
  size?: number;
}) {
  const [pos, setPos] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = scrollHeight > 0 ? window.scrollY / scrollHeight : 0;
      setPos(progress);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const xPercent = reverse ? 100 - pos * 120 : -20 + pos * 120;
  const topPercent = topStart + (topEnd - topStart) * pos;
  const opacity = Math.min(pos * 4, 1) * Math.min((1 - pos) * 4, 1) * 0.18;
  return <div className="absolute pointer-events-none z-[1]" style={{
    top: `${topPercent}%`,
    left: `${xPercent}%`,
    opacity,
    transition: 'opacity 0.3s ease',
    filter: 'drop-shadow(0 4px 12px rgba(139,92,138,0.15))'
  }} data-id="element-3348" data-mp="27jnoitc7hih1">
      {/* Vapor trail */}
      <svg className="absolute" style={{
      [reverse ? 'left' : 'right']: '100%',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 160,
      height: 20
    }} viewBox="0 0 160 20" fill="none" data-id="element-3349" data-mp="22snq1jnfuscf">
        <defs data-id="element-3350" data-mp="1evrqnlawhkio">
          <linearGradient id={`trail-${reverse ? 'r' : 'f'}-${topStart}`} x1={reverse ? '0%' : '100%'} y1="0%" x2={reverse ? '100%' : '0%'} y2="0%" data-id="element-3351" data-mp="1ew9x1ara1f4b">
            <stop offset="0%" stopColor="rgba(139,92,138,0.3)" data-id="element-3352" data-mp="39auelekawujh" />
            <stop offset="100%" stopColor="rgba(139,92,138,0)" data-id="element-3353" data-mp="3e8cg4jvzo7hg" />
          </linearGradient>
        </defs>
        <path d={reverse ? 'M0,10 Q40,4 80,10 Q120,16 160,10' : 'M0,10 Q40,16 80,10 Q120,4 160,10'} stroke={`url(#trail-${reverse ? 'r' : 'f'}-${topStart})`} strokeWidth="2" fill="none" data-id="element-3354" data-mp="3bugzg27j3qkf" />
        <path d={reverse ? 'M0,10 Q40,4 80,10 Q120,16 160,10' : 'M0,10 Q40,16 80,10 Q120,4 160,10'} stroke={`url(#trail-${reverse ? 'r' : 'f'}-${topStart})`} strokeWidth="1" strokeDasharray="4 6" fill="none" opacity="0.5" data-id="element-3355" data-mp="2xufw8g3sk71s" />
      </svg>
      <div className="text-plum-400" style={{
      transform: `rotate(${reverse ? '15deg' : '-15deg'})`
    }} data-id="element-3356" data-mp="3lqk7fop2ajfa">
        <RealisticPlane flip={reverse} size={size} data-id="element-3357" data-mp="i2s4cz3mx4pu" />
      </div>
    </div>;
}
export function TravelPage() {
  return <div className="min-h-screen bg-gradient-to-b from-[#dce6f5] via-[#e8dff0] to-[#f5e8f0] pt-24 pb-12 relative overflow-hidden" data-id="element-3358" data-mp="dc20jqaux9x9">
      {/* Scroll-driven airplane shadows */}
      <ScrollPlane topStart={5} topEnd={15} size={48} data-id="element-3359" data-mp="pmb1085swwgw" />
      <ScrollPlane topStart={35} topEnd={50} reverse size={40} data-id="element-3360" data-mp="pmt9q49nh35p" />
      <ScrollPlane topStart={65} topEnd={80} size={44} data-id="element-3361" data-mp="ule6ftpp14pe" />

      {/* Hero — Image as Background */}
      <section className="relative flex items-start overflow-hidden" data-id="element-3362" data-mp="zl0kg5dcioz9">
        {/* Background image — full, no cropping */}
        <img src="https://cdn.magicpatterns.com/uploads/sT7KuakbeFFzciYF9k6zMP/ChatGPT_Image_Mar_21,_2026,_08_52_39_PM.png" alt="" className="absolute inset-0 w-full h-full object-contain object-top" aria-hidden="true" data-id="element-3363" data-mp="13lsvn45s33y6" />
        {/* Match the image aspect ratio so nothing is cropped */}
        <div className="w-full" style={{
        paddingBottom: '66.67%'
      }} data-id="element-3364" data-mp="1nabg58fu9t6j" />
        {/* Soft overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-white/70 via-white/40 to-transparent" data-id="element-3365" data-mp="1rc6goapy42j9" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#dce6f5]/60 via-transparent to-[#dce6f5]/30" data-id="element-3366" data-mp="2cl21p0p4pvjp" />

        {/* Sparkles over the background */}
        <SparkleEffect count={90} data-id="element-3367" data-mp="2mlb1spm8s14d" />

        {/* Twinkling stars */}
        {[{
        top: '12%',
        right: '15%',
        delay: 0,
        size: 'w-3 h-3'
      }, {
        top: '25%',
        right: '30%',
        delay: 0.5,
        size: 'w-2 h-2'
      }, {
        top: '18%',
        right: '45%',
        delay: 1,
        size: 'w-2.5 h-2.5'
      }, {
        bottom: '25%',
        right: '20%',
        delay: 0.8,
        size: 'w-2 h-2'
      }, {
        bottom: '35%',
        right: '40%',
        delay: 1.3,
        size: 'w-3 h-3'
      }, {
        top: '40%',
        right: '10%',
        delay: 1.6,
        size: 'w-1.5 h-1.5'
      }].map((spark, i) => <motion.div key={i} className={`absolute z-10 ${spark.size} rounded-full bg-white`} style={{
        top: spark.top,
        bottom: spark.bottom,
        right: spark.right,
        boxShadow: '0 0 8px 3px rgba(255,255,255,0.9), 0 0 20px 6px rgba(200,180,220,0.5)'
      }} animate={{
        opacity: [0, 1, 0.3, 1, 0],
        scale: [0.5, 1.3, 0.7, 1.2, 0.5]
      }} transition={{
        duration: 3.5,
        delay: spark.delay,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-3368" data-mp="3mlejs2cga0el" data-mpi={i} />)}

        {/* Text content — positioned at top over the background */}
        <div className="absolute top-0 left-0 right-0 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 z-10 pt-[30%] md:pt-[22%]" data-id="element-3369" data-mp="2g6vpx9wrqqnu">
          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} className="font-heading text-5xl md:text-6xl lg:text-7xl font-bold text-plum-700 mb-6 drop-shadow-sm whitespace-nowrap" data-id="element-3370" data-mp="2vd9o8bgfahnv">
            Trippin' Through <span className="shimmer-text" data-id="element-3371" data-mp="2qclon1e4osi1">Travel</span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.15
        }} className="text-xl md:text-2xl text-plum-600 font-medium max-w-lg drop-shadow-sm" data-id="element-3372" data-mp="2cmibr1152b59">
            Because everybody deserves to get the hell out sometimes.
          </motion.p>
        </div>
      </section>

      {/* Philosophy Section — pulled up onto background */}
      <section className="mt-0 md:-mt-[25%] relative z-10 py-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3373" data-mp="1xrlrtqjyvzcc">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="prose prose-lg prose-plum mx-auto text-plum-700 leading-relaxed text-center bg-white/40 backdrop-blur-sm rounded-3xl p-8 md:p-12 border border-white/50 shadow-lg" data-id="element-3374" data-mp="1f31voxiqbwyi">
          <p className="text-2xl font-heading text-plum-700 mb-8 font-bold" data-id="element-3375" data-mp="1t1i0gix17de0">
            I believe travel is healing.
          </p>
          <p className="mb-6 font-medium" data-id="element-3376" data-mp="26r3dzds2b0en">
            Getting out of your everyday environment, seeing something new,
            breathing different air — it changes you. It resets your nervous
            system and reminds you that the world is bigger than whatever you're
            going through right now.
          </p>
          <p className="mb-6 font-medium" data-id="element-3377" data-mp="2bpd9jphp830s">
            I don't care if your budget is $200 or $2,000. I will find you
            something. A weekend getaway, a road trip, a beach somewhere —
            everyone deserves to escape.
          </p>
          <p className="text-xl text-cta-500 font-bold mt-8" data-id="element-3378" data-mp="1iehvha6i3n4s">
            Tell me your budget, tell me your dream, and let me make it happen.
          </p>
        </motion.div>
      </section>

      {/* How It Works */}
      <section className="py-14 bg-blush-50" data-id="element-3379" data-mp="1s3rnkq1ch5sw">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-3380" data-mp="1x3mf8vsy1zf0">
          <h2 className="font-heading text-4xl font-bold text-plum-700 mb-16" data-id="element-3381" data-mp="1x5qto7ogygtj">
            How It Works
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-3382" data-mp="264c7xqmwr9oi">
            <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-blush-200" data-id="element-3383" data-mp="263j716amreea" />

            {[{
            icon: <MapIcon data-id="element-3384" data-mp="bprsbsdg24bz" />,
            title: '1. Book Your Free Consultation',
            desc: "No judgment, just honesty. Tell me your budget, your vibe, and your must-haves. I'll work with what you have and go from there."
          }, {
            icon: <CompassIcon data-id="element-3385" data-mp="3qmd0pujg4qjz" />,
            title: '2. I Build Your Perfect Trip',
            desc: 'I research, compare, and put together a personalized travel plan that fits your budget—flights, stays, activities, all of it.'
          }, {
            icon: <PlaneIcon data-id="element-3386" data-mp="n3k0ejfohy7r" />,
            title: '3. You Pack Your Bags & Go',
            desc: 'You get your itinerary, book with confidence, and go live your best life. Come back recharged and ready.'
          }].map((step, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.2
          }} className="relative z-10" data-id="element-3387" data-mp="94tt6az5ai5o" data-mpi={i}>
                <div className="w-24 h-24 mx-auto bg-white rounded-full shadow-sm border border-blush-100 flex items-center justify-center text-cta-500 mb-6" data-id="element-3388" data-mp="bphzao0e20vq">
                  {cloneElement(step.icon as React.ReactElement, {
                className: 'w-10 h-10'
              })}
                </div>
                <h3 className="font-heading text-2xl font-bold text-plum-700 mb-3" data-id="element-3389" data-mp="19d8p82x7gugq">
                  {step.title}
                </h3>
                <p className="text-plum-500 font-medium" data-id="element-3390" data-mp="vcxv8r0lmzrc">{step.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Travel Types */}
      <section className="py-14 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3391" data-mp="3g2nah557snkk">
        <div className="text-center mb-16" data-id="element-3392" data-mp="3k5a5tg13gqmi">
          <h2 className="font-heading text-4xl font-bold text-plum-700 mb-4" data-id="element-3393" data-mp="3k6cwbmui8r1w">
            What We Can Plan
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-3394" data-mp="37mo970xt1iuc">
          {[{
          title: 'Budget Getaways',
          desc: 'Weekend trips and local escapes under $500.',
          color: 'bg-blush-50 border-blush-100'
        }, {
          title: 'Healing Retreats',
          desc: 'Wellness-focused travel experiences to reset your soul.',
          color: 'bg-lavender-50 border-lavender-100'
        }, {
          title: 'Adventure Trips',
          desc: 'For when you need to feel alive and push your boundaries.',
          color: 'bg-sky-50 border-sky-100'
        }, {
          title: 'Group Travel',
          desc: 'Coming soon: group trips with the community. We rise together.',
          color: 'bg-white border-plum-100',
          badge: 'Coming Soon'
        }].map((type, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`p-8 rounded-3xl border ${type.color} shadow-sm relative`} data-id="element-3395" data-mp="2vtc52n422jqu" data-mpi={i}>
              {type.badge && <div className="absolute top-4 right-4 px-2 py-1 bg-plum-100 text-plum-700 text-xs font-bold rounded-md uppercase" data-id="element-3396" data-mp="2gyedvxkn80bc">
                  {type.badge}
                </div>}
              <SparklesIcon className="w-6 h-6 text-cta-500 mb-4" data-id="element-3397" data-mp="2qs4wilu39gj4" />
              <h3 className="font-heading text-xl font-bold text-plum-700 mb-2" data-id="element-3398" data-mp="14e3a16wmjla">
                {type.title}
              </h3>
              <p className="text-plum-500 font-medium text-sm" data-id="element-3399" data-mp="66d1yxrp8sbw">{type.desc}</p>
            </motion.div>)}
        </div>
      </section>

      {/* TWO TRAVEL FORMS - Side by Side */}
      <section className="py-12 relative overflow-hidden bg-gradient-to-b from-white to-blush-50" data-id="element-3400" data-mp="1lnzva80pc7ky">
        <SparkleEffect count={80} data-id="element-3401" data-mp="1guexafz3zdlr" />
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-3402" data-mp="1bxofno7no9y8">
          <div className="text-center mb-12" data-id="element-3403" data-mp="1bvkdpbtbhl0l">
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-plum-700 mb-4 flex items-center justify-center gap-3" data-id="element-3404" data-mp="17wus4vy4kx5v">
              Let Me Plan Your Escape ✈️
            </h2>
            <p className="text-lg text-plum-500 font-medium max-w-2xl mx-auto" data-id="element-3405" data-mp="xwu9lc82yl2q">
              Choose the option that fits you best — whether you already know
              where you want to go, or you want me to surprise you within your
              budget 💕
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-3406" data-mp="2ncbtwhrd8ykh">
            {/* Regular Travel Form */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white/60 backdrop-blur-md p-8 rounded-[2rem] shadow-xl border border-blush-200 relative" data-id="element-3407" data-mp="1w6y4o0mplxkh">
              <div className="absolute -top-4 -right-4 rotate-12" data-id="element-3408" data-mp="1dfyjzbm8z9x0">
                <GlitterHeart size={32} className="opacity-80" data-id="element-3409" data-mp="1igchw0u4x3hb" />
              </div>
              <div className="mb-6" data-id="element-3410" data-mp="14g1rt00nfsx7">
                <h3 className="font-heading text-2xl font-bold text-plum-700 mb-2" data-id="element-3411" data-mp="14h39hnc67dnw">
                  Need to Book Travel?
                </h3>
                <p className="text-plum-500 font-medium text-sm" data-id="element-3412" data-mp="18jgh6hah9lnb">
                  Already know what you want? Ready to book?
                </p>
                <p className="text-cta-500 font-bold text-sm mt-1" data-id="element-3413" data-mp="32umuf7ba2hse">
                  Say less 😏 Fill this out and let's get you out of here ✈️💖
                </p>
              </div>
              <div className="rounded-2xl overflow-hidden border border-blush-200 bg-white shadow-inner" data-id="element-3414" data-mp="n7948efdkojm">
                <iframe src="https://form.jotform.com/261728345435057" title="Travel booking request" width="100%" height="900" frameBorder={0} marginHeight={0} marginWidth={0} scrolling="yes" className="w-full block" data-id="element-3415" data-mp="10ydwuwkbsgkg">
                  Loading…
                </iframe>
              </div>
              <p className="mt-3 text-center text-xs text-plum-400 font-medium" data-id="element-3416" data-mp="1exvqpqchak0o">
                Trouble seeing the form?{' '}
                <a href="https://form.jotform.com/261728345435057" target="_blank" rel="noopener noreferrer" className="text-cta-500 font-bold underline hover:text-cta-600" data-id="element-3417" data-mp="3lnjvpyexvo1r">
                  Open it in a new tab ↗
                </a>
              </p>
            </motion.div>

            {/* Budget Travel Form */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.15
          }} className="bg-white/60 backdrop-blur-md p-8 rounded-[2rem] shadow-xl border border-sky-200 relative" data-id="element-3418" data-mp="2ialwmijdlduo">
              <div className="absolute -top-4 -left-4 -rotate-12" data-id="element-3419" data-mp="1uehvy3vqejvf">
                <GlitterHeart size={32} variant="light" className="opacity-80" data-id="element-3420" data-mp="1ug19hmq06gti" />
              </div>
              <div className="mb-6" data-id="element-3421" data-mp="3ositmlfjp0tx">
                <h3 className="font-heading text-2xl font-bold text-plum-700 mb-2" data-id="element-3422" data-mp="5ums3jnk8g7">
                  Budget Travel Services
                </h3>
                <p className="text-plum-500 font-medium text-sm" data-id="element-3423" data-mp="53mk5d32gmrs">
                  Because everyone deserves to get the hell out sometimes.
                </p>
                <p className="text-plum-500 font-medium text-sm mt-1" data-id="element-3424" data-mp="euh6ehgbbmd8">
                  If you want me to plan a vacation within your budget—where I
                  choose the destination and dates for you—this is for you.
                </p>
                <p className="text-cta-500 font-bold text-sm mt-1" data-id="element-3425" data-mp="3ibzempzzyve6">
                  Fill out this quick questionnaire and let's get you out of
                  here ✈️
                </p>
              </div>
              <div className="rounded-2xl overflow-hidden border border-sky-200 bg-white shadow-inner" data-id="element-3426" data-mp="3sayg9omchqro">
                <iframe src="https://form.jotform.com/261728053052048" title="Budget travel questionnaire" width="100%" height="900" frameBorder={0} marginHeight={0} marginWidth={0} scrolling="yes" className="w-full block" data-id="element-3427" data-mp="12mfnji2g0bya">
                  Loading…
                </iframe>
              </div>
              <p className="mt-3 text-center text-xs text-plum-400 font-medium" data-id="element-3428" data-mp="38mysaog6j0we">
                Trouble seeing the form?{' '}
                <a href="https://form.jotform.com/261728053052048" target="_blank" rel="noopener noreferrer" className="text-cta-500 font-bold underline hover:text-cta-600" data-id="element-3429" data-mp="2ktyu92qcqulp">
                  Open it in a new tab ↗
                </a>
              </p>
            </motion.div>
          </div>

          <p className="mt-8 text-center text-sm font-medium text-plum-500" data-id="element-3430" data-mp="216ivyt2o5jmx">
            I'll personally review your request and reach out with options that
            fit your vibe and your budget.
          </p>

          <div className="mt-6 flex justify-center" data-id="element-3431" data-mp="1n0h1a8t3he6a">
            <a href="https://www.tiktok.com/@mandyleedidathing?_r=1&_t=ZP-94syzVPhazm" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/70 backdrop-blur-sm border border-blush-200 text-plum-700 font-bold text-sm hover:bg-white hover:border-cta-300 transition-all shadow-sm" data-id="element-3432" data-mp="1rtilmwc2m5x9">
              <svg className="w-5 h-5 text-cta-500" viewBox="0 0 24 24" fill="currentColor" data-id="element-3433" data-mp="2aqthe6yhuh7y">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-3434" data-mp="20torpx5fw3me" />
              </svg>
              Follow my Travel TikTok ✈️
            </a>
          </div>
        </div>
      </section>
    </div>;
}